import { render, staticRenderFns } from "./approveCompany.vue?vue&type=template&id=1341451f&scoped=true&"
import script from "./approveCompany.vue?vue&type=script&lang=js&"
export * from "./approveCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1341451f",
  null
  
)

export default component.exports